module.exports = __webpack_public_path__ + "assets/img/paperwalletemptyBg.82c4ee63b70a42600395ab25bf0221fd.svg";